import { ComponentProps } from "react";

export function TopAttractionsStory(props: ComponentProps<"svg">) {
    return (
        <svg {...props} width="40" height="40" viewBox="0 0 40 40">
            <path d="M20 5C28.2617 5 35 11.7383 35 20C35 28.3203 28.2617 35 20 35C11.6797 35 5 28.3203 5 20C5 11.7383 11.6797 5 20 5ZM28.4961 18.5937C29.082 17.9492 28.7891 16.8945 27.9102 16.7773L23.0469 16.0742L20.9375 11.6797C20.5273 10.918 19.4141 10.918 19.0039 11.6797L16.8945 16.0742L12.0312 16.7773C11.1523 16.8945 10.8594 17.9492 11.4453 18.5937L14.9609 21.9922L14.1406 26.7383C13.9648 27.6172 14.9023 28.2617 15.6641 27.8516L20 25.625L24.2773 27.8516C25.0391 28.2617 25.9766 27.6172 25.8008 26.7383L24.9805 21.9922L28.4961 18.5937Z" />
        </svg>
    );
}
